var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 15.3462C20.0572 15.3462 20.7115 16.0005 20.7115 16.8077V25.5769C20.7115 26.3841 20.0572 27.0385 19.25 27.0385C18.4428 27.0385 17.7885 26.3841 17.7885 25.5769V16.8077C17.7885 16.0005 18.4428 15.3462 19.25 15.3462ZM19.25 10.2308C20.0572 10.2308 20.7115 10.8851 20.7115 11.6923C20.7115 12.4995 20.0572 13.1538 19.25 13.1538C18.4428 13.1538 17.7885 12.4995 17.7885 11.6923C17.7885 10.8851 18.4428 10.2308 19.25 10.2308ZM5.82212 5.57212C9.53688 1.85735 14.0128 0 19.25 0C24.4872 0 28.9631 1.85735 32.6779 5.57212C36.3926 9.28688 38.25 13.7628 38.25 19C38.25 24.2372 36.3926 28.7131 32.6779 32.4279C28.9631 36.1426 24.4872 38 19.25 38C14.0128 38 9.53688 36.1426 5.82212 32.4279C2.10735 28.7131 0.25 24.2372 0.25 19C0.25 13.7628 2.10735 9.28688 5.82212 5.57212ZM7.4025 30.8475C10.6789 34.1239 14.628 35.762 19.25 35.762C23.872 35.762 27.8211 34.1239 31.0975 30.8475C34.3739 27.5711 36.012 23.622 36.012 19C36.012 14.378 34.3739 10.4289 31.0975 7.1525C27.8211 3.87614 23.872 2.23798 19.25 2.23798C14.628 2.23798 10.6789 3.87614 7.4025 7.1525C4.12614 10.4289 2.48798 14.378 2.48798 19C2.48798 23.622 4.12614 27.5711 7.4025 30.8475Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.94ade8c8d25fcf524615952fb08e2979.svg";
export { ForwardRef as ReactComponent };